import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../model/card';

@Component({
    selector: 'app-minimal-cards',
    templateUrl: './minimal-cards.component.html',
    styleUrls: ['./minimal-cards.component.scss'],
    standalone: false
})
export class MinimalCardsComponent implements OnInit {
  @Input() public datos: Card;

  constructor() { }

  ngOnInit() {}

}
